/** @typedef {import("../../data/products.js").Product} Product */

/** @param {{product: Product, className?: string}} props */
export function ProductPreview({ product, className = "" }) {
  if (!product.image) {
    return `
      <div class="product-preview product-placeholder ${className}" role="img" aria-label="${product.imageAlt}">
        <div class="placeholder-toolbar"><span></span><span></span><span></span></div>
        <div class="placeholder-layout">
          <div class="placeholder-nav"></div>
          <div class="placeholder-content">
            <div class="placeholder-heading"></div>
            <div class="placeholder-stats"><span></span><span></span><span></span></div>
            <div class="placeholder-table"></div>
          </div>
        </div>
      </div>
    `;
  }

  return `
    <div class="product-preview ${className}">
      <div class="preview-browser" aria-hidden="true"><span></span><span></span><span></span><b>${product.name}</b></div>
      <img src="${product.image}" alt="${product.imageAlt}" width="1440" height="1050" loading="lazy" decoding="async" />
    </div>
  `;
}
